import React, { useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import {
    capitalizeFirstLetter,
    formatDate,
    numberFormat,
} from "../../Helpers/Utils/Common";
import Footer from "../../Components/Footer/Footer";

export default function ReiewTransfer() {
    const { id, type } = useParams();
    let navigate = useNavigate();

    const [inactive, setInactive] = useState(true);
    const [transaction, setTransaction] = useState([]);
    const [items, setItems] = useState([]);

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="sentence">
                                    {item.invoice_label
                                        ? item.invoice_label
                                        : `Invoice ID: ${item.receive_id} was deleted or does not exist.`}
                                </td>
                                <td>{formatDate(item.added_on)}</td>
                                <td>
                                    <button
                                        type="button"
                                        className="button-primary view-btn me-3"
                                        onClick={() =>
                                            handleViewPayment(
                                                item.se_id,
                                                id,
                                                type
                                            )
                                        }
                                    >
                                        View
                                    </button>
                                </td>
                                <td>PHP {numberFormat(item.amount)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    function handleViewPayment(id, bank, type) {
        {
            window.open(
                "/se/paysuppliers/view-invoice/" + id + "/" + bank + "/" + type,
                "_blank"
            );
        }
    }

    React.useEffect(() => {
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                <Row className="mb-4">
                    <Col xs={12} lg={8}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> VIEW TRANSACTION </h1>
                    </Col>
                    <Col xs={12} lg={1}></Col>
                    <Col xs={12} lg={3} className="PI-header2">
                        <span className="pe-5">DOCUMENT NO.</span>
                        <span>{id}</span>
                    </Col>
                </Row>

                {/* content */}
                <div className="review-form mb-3">
                    {/* TRANSACTION/PAYMENT DETAILS */}

                    <Container fluid>
                        <Row className="review-container py-3">
                            <Row>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Transfer Number
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Doc No.
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Encoded By
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Transfer Date
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span className="review-data">
                                        {transaction.supplier_name}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {transaction.payee}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {transaction.payment_date}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">CASH</span>
                                </Col>
                            </Row>
                        </Row>
                        <Row>
                            <Col>
                                <span className="review-label nc-modal-custom-row">
                                    Dispatcher
                                </span>
                            </Col>
                            <Col>
                                <span className="review-label nc-modal-custom-row">
                                    From Branch
                                </span>
                            </Col>
                            <Col>
                                <span className="review-label nc-modal-custom-row">
                                    To Branch
                                </span>
                            </Col>
                            <Col>
                                <span className="review-label nc-modal-custom-row">
                                    Remarks
                                </span>
                            </Col>
                        </Row>
                    </Container>

                    {/* INVOICES */}
                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            LIST OF ITEMS TRANSFERRED
                        </span>
                        {/* <div className="review-purchased-items">
                            {renderTable()}
                        </div> */}
                    </div>
                    <div className="d-flex mt-2 justify-content-evenly">
                        <div className="print-table mt-3 mx-2">
                            {renderTable()}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end pt-5">
                        <button type="button" className="button-primary me-3">
                            Print
                        </button>
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate(-1)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
